import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { uiReducer } from "./uiReducer";
import { envReducer } from "./envReducer";

export default combineReducers({
    auth: authReducer,
    ui: uiReducer,
    appEnv: envReducer
})